import React, { useState } from 'react';
import '../style/AddStartDate.css'
const AddStartDate = ({ startDate, setStartDate }) => {
  const [focused, setFocused] = useState(false);

  const today = new Date().toISOString().split('T')[0];

  const formatDisplay = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div className="ap-field-group">
      <label className="ap-label">Start Date</label>
      <div className={`ap-date-wrapper ${focused ? 'focused' : ''}`}>
        <span className="ap-date-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </span>

        <input
          type="date"
          className="ap-date-input"
          value={startDate || ''}
        //   min={today}
          onChange={(e) => setStartDate(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />

        {startDate && (
          <span className="ap-date-display">{formatDisplay(startDate)}</span>
        )}

        {startDate && (
          <button
            className="ap-date-clear"
            onClick={() => setStartDate('')}
            type="button"
            title="Clear date"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default AddStartDate;